export const Logo = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='209' height='36' viewBox='0 0 209 36' style={{ width: '100%', height: 'auto' }}>
      <path fill='#fff' d='M11.76,27.88l-4.13,7.21H0L20.57,0h.54l20.34,35.09h-7.72l-4.09-7.21H11.76ZM20.7,11.54l-5.76,10.89h11.49l-5.73-10.89Z' />
      <path
        fill='#fff'
        d='M179.3,27.88l-4.13,7.21h-7.63L188.11,0h.54l20.34,35.09h-7.72l-4.09-7.21h-17.88Zm8.95-16.34l-5.76,10.89h11.49l-5.71-10.89h-.01Z'
      />
      <path
        fill='#fff'
        d='M68.32,9.94c-2.13-2.28-5.4-3.63-8.72-3.63-7.4,0-11.62,5.91-11.62,11.8s4.41,11.54,11.57,11.54c3.32,0,6.59-1.5,8.76-3.63v7.94c-2.86,1.17-5.76,2.05-8.95,2.05-11.12,0-19.34-8.3-19.34-17.7S47.93,.05,59.51,.05c3.09,0,6.13,.73,8.8,2v7.89h.01Z'
      />
      <path fill='#fff' d='M81.12,6.67v7.53h12.25v5.81h-12.25v9.26h12.71v5.81h-20.43V.91h20.43V6.72h-12.71v-.05Z' />
      <path fill='#fff' d='M98.96,0h5.54l20.78,23.87h.1V.91h7.72V35.77h-5.54l-20.78-23.87h-.1v23.19h-7.72V0Z' />
      <path
        fill='#fff'
        d='M138.68,.91h10.99c11.44,0,19.07,7.4,19.07,17.12s-7.86,17.02-19.11,17.02h-10.94V.91h0Zm7.72,28.37h1.27c9.49,0,13.17-4.54,13.17-11.31,0-7.44-4.41-11.31-13.17-11.31h-1.27V29.28h0Z'
      />
    </svg>
  );
};
